import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "18"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "#424242",
  "fill-rule": "evenodd",
  d: "M15.144 6.805q.535 0 .946.41t.41.946v1.211a1.4 1.4 0 0 1-.098.505l-2.15 5.071q-.16.36-.54.609a1.4 1.4 0 0 1-.789.248H6.851q-.561 0-.958-.398a1.3 1.3 0 0 1-.398-.958V7.366q0-.271.111-.522a1.5 1.5 0 0 1 .296-.435L9.87 2.468a.97.97 0 0 1 .518-.261.9.9 0 0 1 .563.088.82.82 0 0 1 .39.402.85.85 0 0 1 .047.564l-.807 3.544zm-12.288 9q-.561 0-.959-.398a1.3 1.3 0 0 1-.397-.958V8.16q0-.561.397-.959c.397-.398.585-.397.959-.397h.158q.561 0 .959.397c.398.397.397.585.397.959v6.295q0 .56-.397.955a1.31 1.31 0 0 1-.959.394z"
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }